/* eslint-disable */
export default {
  allCalls: 'Alle Anrufe',
  Unknown: 'Unbekannt',
  Multiple: 'Mehrere',
} as const;

// @key: @#@"allCalls"@#@ @source: @#@"All calls"@#@
// @key: @#@"Unknown"@#@ @source: @#@"Unknown"@#@
// @key: @#@"Multiple"@#@ @source: @#@"Multiple"@#@
